export const buttons = {
  base: {
    borderWidth: 0,
    borderRadius: 100,
    flexDirection: 'row',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  },
  // SIZE: default, small, medium, large
  default: {
    height: 44
  },
  small: {
    height: 28
  },
  medium: {
    height: 36
  },
  large: {
    height: 56
  },
  // TYPE: primary, secondary, alternative
  primary: {},
  secondary1: {
    borderWidth: 1
  },
  secondary2: {},
  outline: {
    borderWidth: 1
  }
};

export const borders = {
  base: {
    borderColor: '$borderPrimary'
  },
  primaryButtonDefault: {
    borderColor: 'transparent'
  },
  primaryButtonPressed: {
    borderColor: 'transparent'
  },
  secondary1ButtonDefault: {
    borderColor: '$borderPrimary'
  },
  secondary1ButtonPressed: {
    borderColor: '$borderPrimary'
  },
  secondary2ButtonDefault: {
    borderColor: 'transparent'
  },
  secondary2ButtonPressed: {
    borderColor: 'transparent'
  },
  outlineButtonDefault: {
    borderColor: '$borderPrimary'
  },
  outlineButtonPressed: {
    borderColor: '$borderSecondary'
  },
  buttonDisabled: {
    borderColor: 'transparent'
  }
};
